import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios, { AxiosResponse } from 'axios'
import { CrudState } from '../../interfaces/CrudState'
import { PrefixSimplified, PrefixSimplifiedType } from '../../interfaces/Prefix'
import { getTempoTerminology } from '../../../httpClient/Requests/Api/TEMPO/terminology'
import { getTempoValidation } from '../../../httpClient/Requests/Api/TEMPO/validation'

export const initialState: CrudState = {
    items: [],
    loading: false,
    error: null,
}

export const fetchItems = (prefix: PrefixSimplifiedType) =>
    createAsyncThunk(
        `${prefix}/items/fetchItems`,
        async ({ filterBy }: { filterBy: any; executionCondition?: boolean }, { signal }) => {
            const source = axios.CancelToken.source()
            signal.addEventListener('abort', () => {
                source.cancel()
            })
            let response: AxiosResponse<Record<string, any>[]>
            switch (prefix) {
                case PrefixSimplified.TEMPO_TERMINOLOGY:
                    response = await getTempoTerminology(filterBy, source.token)
                    break
                case PrefixSimplified.TEMPO_VALIDATION:
                    response = await getTempoValidation(filterBy, source.token)
                    break
                default:
                    break
            }
            return response.data
        },
        {
            condition: ({ executionCondition }) => {
                if (!executionCondition) {
                    // Already fetched or in progress, don't need to re-fetch
                    return false
                }
            },
        },
    )

const itemsSlice = (prefix: PrefixSimplifiedType) =>
    createSlice({
        name: `${prefix}/items`,
        initialState,
        reducers: {
            resetProjects: () => initialState,
        },
        extraReducers: (builder) => {
            builder.addCase(fetchItems(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchItems(prefix).fulfilled, (state, action) => ({
                ...state,
                items: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchItems(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

export const itemsActions = (prefix: PrefixSimplifiedType) => itemsSlice(prefix).actions

const items = (prefix: PrefixSimplifiedType) => itemsSlice(prefix).reducer

export default items
